import { render, staticRenderFns } from "./scoreboard_single.vue?vue&type=template&id=25e3915a&scoped=true&"
import script from "./scoreboard_single.vue?vue&type=script&lang=js&"
export * from "./scoreboard_single.vue?vue&type=script&lang=js&"
import style0 from "./scoreboard_single.vue?vue&type=style&index=0&id=25e3915a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e3915a",
  null
  
)

export default component.exports